import SectionLearnings from './sectionLearnings.js';
export default SectionLearnings;
